import { connect } from 'react-redux'
import Flow from './Flow'
import { getFlow, getPricing } from 'features/Flows/Flows.actions'
import { getNumbers } from 'features/Numbers/Numbers.actions'

const stateToProps = ({ flows: { flowsById } }, { routeParams: { flowId } }) => ({
  flow: flowsById[flowId],
  flowId,
})

const dispatchToProps = {
  getFlow,
  getNumbers,
  getPricing,
}

export default connect(stateToProps, dispatchToProps)(Flow)



// WEBPACK FOOTER //
// ./src/pages/Flow/Flow.container.js